import { Action } from '@ngrx/store';
import { OrderULResponse } from '@cemex-core/cmx-api';

export enum SimulateActionTypes {
  LOAD = '[Rms Simulate Open Platform] Load simulate',
  LOAD_COMPLETE = '[Rms Simulate Open Platform] Load complete simulate',
  RESET = '[Rms Simulate Open Platform] Reset',
}

export class SimulateLoadAction implements Action {
  readonly type = SimulateActionTypes.LOAD;

  constructor() {}
}

export class SimulateLoadCompleteAction implements Action {
  readonly type = SimulateActionTypes.LOAD_COMPLETE;

  constructor(public payload: OrderULResponse) {}
}

export class SimulateResetAction implements Action {
  readonly type = SimulateActionTypes.RESET;

  constructor() {}
}

export type SimulateActions = SimulateLoadAction | SimulateLoadCompleteAction | SimulateResetAction;
